import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'
import { List } from 'immutable'

import { post } from 'utils/http'

export const useAuditEvents = (reportType: any, data: any, transform = (x: any) => x) => {
  const customerId = useCustomerId()
  const queryKey = ['customer', customerId, 'audit', reportType, data]

  const getAuditData = async () => {
    const body: any = await post('/management/audit/reports', { ...data, customer_id: customerId, name: reportType })

    return List(body.items)
  }

  return useQuery({
    queryKey,
    queryFn: () => getAuditData(),
    enabled: !!reportType && !!data.date_from && !!data.date_to,
    select: transform,
    staleTime: 60 * 60 * 1000,
  })
}
